<div class="logo-container">
	<div class="logo-wrapper">
		<img src="../../../assets/images/Vitralogy_Logo_Blue.png" />
		<div *ngIf="!isOnline" class="offline-indicator">
			<mat-icon style="width: 24px; height: 24px;" [svgIcon]="'signal_disconnected'"></mat-icon> Offline
		</div>
	</div>
	<div class="help-support-wrapper">
		<button *ngIf="hasUserAccountId" mat-icon-button type="button" (click)="onToggleHelpVisibility(true)">
			<mat-icon class="help-support-icon" [svgIcon]="'help_support'"></mat-icon>
		</button>
	</div>
</div>

<div class="job-completed" *ngIf="GlobalSettingsService.isJobCompletedStatusVisible"><span>Completed</span></div>

<app-preferences-modal></app-preferences-modal>
<mat-icon style="width: 0; height: 0;" [svgIcon]="'signal_disconnected'"></mat-icon>
<div class="nav-actions-container">
	<ng-container *ngIf="!!navigationBarActionIds?.length">
		<ng-container *ngTemplateOutlet="buttonsListTemplate; context: { buttons: navigationBarActionIds }"></ng-container>
	</ng-container>

	<ng-container *ngIf="!!dropdownMenuActionIds?.length">
		<div class="dropdown-menu-container" (click)="$event.stopPropagation(); $event.preventDefault();">
			<button mat-button color="primary" (click)="isDropdownOpen = !isDropdownOpen">
				<mat-icon *ngIf="!isDropdownOpen">menu</mat-icon>
				<mat-icon *ngIf="isDropdownOpen">close</mat-icon>
			</button>

			<div class="dropdown-menu" *ngIf="isDropdownOpen" @fadeIn @fadeOut>
				<ng-container *ngTemplateOutlet="buttonsListTemplate; context: { buttons: dropdownMenuActionIds, isDropdown: true }"></ng-container>
			</div>
		</div>
	</ng-container>
</div>

<ng-template #buttonsListTemplate let-buttons="buttons" let-isDropdown="isDropdown">
	<button mat-button color="primary" *ngFor="let id of buttons; let index"
		[matTooltip]="actions.get(id).text" 
		[disabled]="actions.get(id).isDisabled || !actions.get(id).action"
		(click)="!!actions.get(id).action && actions.get(id).action(); isDropdownOpen = false;">

		<mat-icon *ngIf="actions.get(id).icon && !actions.get(id).isCustomSvgIcon" [class.disabled]="actions.get(id).isDisabled">
			{{ actions.get(id).icon }}
		</mat-icon>

		<mat-icon *ngIf="actions.get(id).icon && actions.get(id).isCustomSvgIcon" [svgIcon]="actions.get(id).icon" [class.disabled]="actions.get(id).isDisabled">
		</mat-icon>

		<span *ngIf="(isDropdown || (!isDropdown && !actions.get(id).isTextOnlyShownInDropdown)) && !!actions.get(id).text">
			{{ actions.get(id).text }}
		</span>
	</button>
</ng-template>

<app-help-request-modal [sites]="sites" [isVisible]="isHelpRequestModalVisible" (onToggleVisibility)="onToggleHelpVisibility($event)"></app-help-request-modal>